<template>
	<widget-settings-layout ref="layout" v-if="settings" slug="emoteWall" name="Emote Wall" :error="saveError" :saving="saving" :has-unsaved-changes="hasUnsavedChanges" :settings="settings" :saved-settings-json="savedSettingsJson" @save="save">
		<b-card class="mb-3">
			<b-form-row class="mb-3">
				<b-col><b-form-checkbox v-model="settings.showEmojis">Show emojis</b-form-checkbox></b-col>
				<b-col class="text-center"><b-form-checkbox v-model="settings.physics">Physics simulation</b-form-checkbox></b-col>
				<b-col class="text-right"><b-form-checkbox v-model="settings.physicsHulls" :disabled="!settings.physics">Precise shapes</b-form-checkbox></b-col>
			</b-form-row>
			<b-form-row>
				<b-col>
					<b-form-group label="Duration" append="seconds">
						<b-input-group :append="`${settings.duration} seconds`">
							<b-input type="range" v-model="settings.duration" min="1" max="120"></b-input>
						</b-input-group>
					</b-form-group>
					<b-form-group label="Emote and emoji size">
						<b-input type="range" v-model="settings.emoteSize" min="1" max="20"></b-input>
					</b-form-group>
					<b-form-group label="Sticker and gift size">
						<b-input type="range" v-model="settings.stickerSize" min="1" max="40"></b-input>
					</b-form-group>
					<b-form-group label="Max objects on screen" description="0 = unlimited">
						<b-input type="number" v-model.number="settings.objectLimit" min="0" max="500"></b-input>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Gravity" append="seconds" :disabled="!settings.physics">
						<b-input-group append="N">
							<b-input v-model="settings.gravity" min="0" max="100" step="any"></b-input>
						</b-input-group>
					</b-form-group>
					<b-form-group label="Extra shapes" description="Input one convex fixed collision shape per line, in the format X1,Y1 X2,Y2 ..." :disabled="!settings.physics">
						<b-textarea v-model="settings.shapes"></b-textarea>
					</b-form-group>
				</b-col>
			</b-form-row>
		</b-card>
		<template #preview>
			<emote-wall-widget-preview :settings="settings" />
		</template>
	</widget-settings-layout>
</template>

<script>
import WidgetSettingsLayout from '@/components/Widget/WidgetSettingsLayout.vue';
import EmoteWallWidgetPreview from '@/components/Widget/EmoteWallWidgetPreview.vue';

export default {
	beforeRouteLeave(to, from, next) {
		if (!this.hasUnsavedChanges) return next();
		this.$refs.layout.showLeaveModal(next, () => this.save());
	},
	data() { return {
		settings: null,
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		savedSettingsJson: null,
	}; },
	components: {
		WidgetSettingsLayout,
		EmoteWallWidgetPreview,
	},
	async mounted() {
		window.addEventListener('beforeunload', this._onBeforeUnload);
		try {
			this.loading++;
			this.error = null;
			const settings = await this.$api.get('widgetSettings/emote-wall');
			this.settings = {
				...settings,
				physics: !!settings.physics,
				physicsHulls: !!settings.physicsHulls,
				showEmojis: !!settings.showEmojis,
				duration: settings.duration || 15,
				emoteSize: settings.emoteSize || 5,
				stickerSize: settings.stickerSize || 5,
				objectLimit: settings.objectLimit ?? 50,
			};
			this.savedSettingsJson = JSON.stringify(this.settings);
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	computed: {
		hasUnsavedChanges() {
			if (this.savedSettingsJson === null) return false;
			return JSON.stringify(this.settings) !== this.savedSettingsJson;
		},
	},
	beforeDestroy() {
		window.removeEventListener('beforeunload', this._onBeforeUnload);
	},
	methods: {
		_onBeforeUnload(e) {
			if (this.hasUnsavedChanges) {
				e.preventDefault();
				e.returnValue = '';
			}
		},
		async save() {
			try {
				this.saveError = null;
				this.saving++;
				await this.$api.post('widgetSettings/emote-wall', this.settings);
				this.savedSettingsJson = JSON.stringify(this.settings);
			} catch(e) {
				console.error('Error saving widget:', e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
